import { IncidentsGridController } from '../controller/IncidentsGridController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class IncidentsGridWebComponent extends BaseWebComponentElement {
  private _externalFilters: Array<any>;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IncidentsGridController,
    });
  }

  setPageNumber(page: number) {
    if (this.controller) {
      this.controller.view.dom.$grid.pageNumber = page || 1;
    }
  }

  public set externalFilters(externalFilters) {
    this._externalFilters = externalFilters;
  }

  public get externalFilters() {
    return this._externalFilters ?? [];
  }

  public async reload() {
    await this.controller?.view.dom.$grid.controller?.handleGridItemsLoad(true);
  }
}
